// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import {SettingsTabContainer, SettingsTabContent} from '@app/features/app/components/dialogs/shared/SettingsTabLayout';
import {VideoTab} from '@app/features/user/components/modals/tabs/VideoTab';
import {VoiceTab} from '@app/features/user/components/modals/tabs/VoiceTab';
import {VoiceDiagnosticsSection} from '@app/features/user/components/modals/tabs/voice_video_tab/VoiceDiagnosticsSection';
import Users from '@app/features/user/state/Users';
import VoiceSettings from '@app/features/voice/state/VoiceSettings';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

const VoiceVideoTab: React.FC = observer(() => {
	const {t} = useLingui();
	const user = Users.currentUser;
	const voiceSettings = VoiceSettings;
	const hasPremium = user?.isPremium() ?? false;
	return (
		<SettingsTabContainer>
			<SettingsTabContent>
				<SettingsSection
					id="audio"
					title={t`Audio`}
					description={t`Configure your microphone, speakers, and input mode`}
				>
					<VoiceTab voiceSettings={voiceSettings} hasPremium={hasPremium} />
				</SettingsSection>
				<SettingsSection id="video" title={t`Video`} description={t`Configure your camera and video settings`}>
					<VideoTab voiceSettings={voiceSettings} hasPremium={hasPremium} />
				</SettingsSection>
				<SettingsSection
					id="diagnostics"
					title={t`Diagnostics`}
					description={t`Upload a voice diagnostics bundle for troubleshooting audio, video, and screen sharing issues.`}
				>
					<VoiceDiagnosticsSection />
				</SettingsSection>
			</SettingsTabContent>
		</SettingsTabContainer>
	);
});

export default VoiceVideoTab;
